/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Home_Pulse_EntryInputs */

const id_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entri`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entri`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const ms_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entri`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entri`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const da_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`post`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`poster`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const de_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Eintrag`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Einträge`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const en_us2_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entry`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entries`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const es_es2_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entrada`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entradas`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const es_mx2_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entrada`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entradas`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const fil_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entry`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entry`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const fr_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entrée`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entrées`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const it_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`inserimento`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`inserimenti`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const hu_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`bejegyzés`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`bejegyzés`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const nl_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`vermelding`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`vermeldingen`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const no_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`oppføring`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`oppføringer`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const pl_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`wpis`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`wpisy`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const pt_br2_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entrada`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entradas`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const pt_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`entrada`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`entradas`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const ro_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`intrare`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`intrări`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const fi_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`merkintä`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`merkintää`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const sv_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`post`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`poster`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const vi_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`mục`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`mục`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const tr_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`girdi`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`girdi`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const cs_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`záznam`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`záznamů`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const bg_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`запис`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`записа`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const ru_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`достижение`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`достижений`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const uk_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`запис`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`записів`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const ar_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`مدخل`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`مدخلات`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const hi_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`प्रविष्टि`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`प्रविष्टियाँ`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const th_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`รายการ`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`รายการ`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const ja_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`エントリー`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`エントリー`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const zh_cn2_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`条目`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`条目`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const zh_hant1_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`條目`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`條目`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

const ko_home_pulse_entry = /** @type {(inputs: Home_Pulse_EntryInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`항목`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`항목`);
	return /** @type {LocalizedString} */ ("home.pulse.entry");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "entry" |
* | "other" | "entries" |
*
* @param {Home_Pulse_EntryInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_entry = /** @type {((inputs: Home_Pulse_EntryInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_EntryInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_entry(inputs)
	if (locale === "ms") return ms_home_pulse_entry(inputs)
	if (locale === "da") return da_home_pulse_entry(inputs)
	if (locale === "de") return de_home_pulse_entry(inputs)
	if (locale === "en-US") return en_us2_home_pulse_entry(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_entry(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_entry(inputs)
	if (locale === "fil") return fil_home_pulse_entry(inputs)
	if (locale === "fr") return fr_home_pulse_entry(inputs)
	if (locale === "it") return it_home_pulse_entry(inputs)
	if (locale === "hu") return hu_home_pulse_entry(inputs)
	if (locale === "nl") return nl_home_pulse_entry(inputs)
	if (locale === "no") return no_home_pulse_entry(inputs)
	if (locale === "pl") return pl_home_pulse_entry(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_entry(inputs)
	if (locale === "pt") return pt_home_pulse_entry(inputs)
	if (locale === "ro") return ro_home_pulse_entry(inputs)
	if (locale === "fi") return fi_home_pulse_entry(inputs)
	if (locale === "sv") return sv_home_pulse_entry(inputs)
	if (locale === "vi") return vi_home_pulse_entry(inputs)
	if (locale === "tr") return tr_home_pulse_entry(inputs)
	if (locale === "cs") return cs_home_pulse_entry(inputs)
	if (locale === "bg") return bg_home_pulse_entry(inputs)
	if (locale === "ru") return ru_home_pulse_entry(inputs)
	if (locale === "uk") return uk_home_pulse_entry(inputs)
	if (locale === "ar") return ar_home_pulse_entry(inputs)
	if (locale === "hi") return hi_home_pulse_entry(inputs)
	if (locale === "th") return th_home_pulse_entry(inputs)
	if (locale === "ja") return ja_home_pulse_entry(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_entry(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_entry(inputs)
	return ko_home_pulse_entry(inputs)
});
export { home_pulse_entry as "home.pulse.entry" }